import React from 'react';
import { useNavigate } from 'react-router-dom';
import { updateService } from '../services/api';

const STATUS = {
  OK:      { color: '#16A34A', bg: '#DCFCE7', label: 'Opérationnel', dot: '#16A34A' },
  WARN:    { color: '#EA580C', bg: '#FFEDD5', label: 'Dégradé',      dot: '#EA580C' },
  DOWN:    { color: '#DC2626', bg: '#FEE2E2', label: 'En échec',     dot: '#DC2626' },
  UNKNOWN: { color: '#64748B', bg: '#F1F5F9', label: 'Inconnu',      dot: '#CBD5E1' },
};

const ICON = {
  'Amplitude Core Banking': '🏦',
  'Amplitude Signature':    '✍️',
  'Exstream':               '📄',
  'AIF':                    '📊',
  'SIOP':                   '🔐',
  'Moteur de Scoring':      '⚙️',
  'Application Mobile':     '📱',
  'Internet Banking':       '🖥️',
  'USSD Banking':           '📡',
  'Bus Applicatif ESB':     '🔄',
  'Switch Monétique':       '💳',
  'SWIFT Gateway':          '📨',
  'PI-SPI BCEAO':           '🏛️',
};

export default function ServiceCard({ service, onDelete, onToggleActive, onEdit }) {
  const navigate = useNavigate();
  const st       = STATUS[service.last_status] || STATUS.UNKNOWN;
  const icon     = ICON[service.name] || '🔧';
  const uptime   = parseFloat(service.uptime_30d || 100).toFixed(2);
  const isActive = service.active === true || service.active === 1;
  const borderColor = {
    OK: '#16A34A', WARN: '#EA580C', DOWN: '#DC2626', UNKNOWN: '#CBD5E1',
  }[service.last_status] || '#CBD5E1';

const handleToggle = async (e) => {
  e.stopPropagation();
  try {
    const newActive = !isActive;
    await updateService(service.id, { ...service, active: newActive }); 
    onToggleActive && onToggleActive(service.id, newActive);
  } catch (err) { console.error(err); }
};

  return (
    <div style={{
      background: isActive ? '#fff' : '#F8FAFC',
      border: '1px solid #E2E8F0',
      borderLeft: `4px solid ${isActive ? borderColor : '#CBD5E1'}`,
      borderRadius: 9, padding: '10px 12px',
      cursor: 'pointer', transition: 'box-shadow .15s',
      position: 'relative', overflow: 'hidden',
      opacity: isActive ? 1 : 0.7,
    }}
      onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 2px 10px rgba(37,99,235,.12)'}
      onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
    >

      {/* Badge ALERTE — en haut à droite */}
      {service.last_status === 'DOWN' && isActive && (
        <span style={{
          position: 'absolute', top: 7, right: 7,
          background: '#FEF3C7', border: '1px solid #F59E0B',
          color: '#92400E', fontSize: 8, fontWeight: 700,
          padding: '2px 5px', borderRadius: 4, textTransform: 'uppercase',
        }}>⚠ ALERTE</span>
      )}

      
      {/* Top : icône + statut */}
<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
  <div style={{ width: 30, height: 30, borderRadius: 7, background: st.bg,
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>
    {icon}
  </div>
  <div style={{ display: 'flex', alignItems: 'center', gap: 4,
                fontSize: 9, fontWeight: 600, padding: '2px 7px',
                borderRadius: 20,
                background: !isActive ? '#FEE2E2' : st.bg,
                color: !isActive ? '#DC2626' : st.color,
                textTransform: 'uppercase', letterSpacing: .5 }}>
    <span style={{ width: 5, height: 5, borderRadius: '50%',
                   background: !isActive ? '#DC2626' : st.dot,
                   display: 'inline-block' }} />
    {!isActive ? 'Désactivé' : st.label}
  </div>
</div>

      {/* Nom + catégorie */}
      <div style={{ fontSize: 12, fontWeight: 600, color: '#1B2A4A', marginBottom: 1 }}>
        {service.name}
      </div>
      <div style={{ fontSize: 9, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: .5 }}>
        {service.category}
      </div>

      {/* Métriques */}
      <div style={{ display: 'flex', gap: 10, marginTop: 8,
                    borderTop: '1px solid #F1F5F9', paddingTop: 8 }}>
        <span style={{ fontSize: 10, color: '#64748B' }}>
          Uptime <strong style={{ color: '#1B2A4A' }}>{uptime}%</strong>
        </span>
        <span style={{ fontSize: 10, color: '#64748B' }}>
          Réponse <strong style={{
            color: service.last_status === 'WARN' ? '#EA580C'
                 : service.last_status === 'DOWN' ? '#DC2626' : '#1B2A4A'
          }}>
            {service.last_response_ms ? `${service.last_response_ms} ms` : '—'}
          </strong>
        </span>
      </div>

      {/* Barre d'uptime */}
      <div style={{ height: 3, background: '#F1F5F9', borderRadius: 2,
                    marginTop: 6, overflow: 'hidden' }}>
        <div style={{ height: '100%', borderRadius: 2,
                      width: `${uptime}%`, background: borderColor }} />
      </div>

      {/* ── Actions bas de carte ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', marginTop: 10,
                    paddingTop: 8, borderTop: '1px solid #F1F5F9' }}>

        {/* Toggle actif / inactif — à gauche */}
        <button
  onClick={handleToggle}
  title={isActive ? 'Cliquer pour désactiver' : 'Cliquer pour activer'}
  style={{
    display: 'flex', alignItems: 'center', gap: 5,
    background: isActive ? '#DCFCE7' : '#FEF2F2',
    border: `1px solid ${isActive ? '#BBF7D0' : '#FECACA'}`,
    color: isActive ? '#16A34A' : '#DC2626',
    borderRadius: 6, padding: '4px 9px',
    fontSize: 10, fontWeight: 600, cursor: 'pointer',
    transition: 'all .2s',
  }}>
  {/* Indicateur rond animé */}
  <span style={{
    width: 8, height: 8, borderRadius: '50%',
    background: isActive ? '#16A34A' : '#DC2626',
    display: 'inline-block',
    animation: isActive ? 'pulse 1.5s infinite' : 'none',
  }} />
  {isActive ? 'Actif' : 'Inactif'}
</button>

        {/* Éditer + Supprimer — à droite */}
        <div style={{ display: 'flex', gap: 5 }}>
         <button
            onClick={(e) => { e.stopPropagation(); onEdit(service.id); }}
            style={{ background: '#EFF6FF', border: '1px solid #BFDBFE',
                    color: '#2563EB', borderRadius: 6, padding: '4px 9px',
                    fontSize: 11, cursor: 'pointer' }}>
            ✏️ Éditer
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(service.id); }}
            title="Supprimer"
            style={{ background: '#FEF2F2', border: '1px solid #FECACA',
                     color: '#DC2626', borderRadius: 6, padding: '4px 9px',
                     fontSize: 11, cursor: 'pointer' }}>
            🗑️
          </button>
        </div>
      </div>

      <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}`}</style>
    </div>
  );
}